import React from "react";
import { LinkListItem, QuickLinksWrapper } from "./styles";
import { Ptag } from "components/core";
import { Button, Divider } from "@mui/material";
import ConcentricCircles from "assets/svgs/concentric_circles.svg";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

function QuickLinks({ title, links, style }) {
  const linkHandler = (url, callback) => {
    if (callback) {
      callback();
      return;
    }
    window.open(url, "_blank");
  };
  return (
    <QuickLinksWrapper style={style}>
      <header>
        <Ptag fontSize="18px" color="white" fontWeight="600">
          {title}
        </Ptag>
      </header>
      <Divider
        sx={{
          borderColor: "#FFFFFF5E",
        }}
      />
      <ul>
        {links.map(({ title, url, callback }) => (
          <LinkListItem
            variant="text"
            endIcon={<ArrowForwardIcon className="arrow-icon" />}
            onClick={() => linkHandler(url, callback)}
          >
            {title}
          </LinkListItem>
        ))}
      </ul>
      <img src={ConcentricCircles} alt="" srcset="" />
    </QuickLinksWrapper>
  );
}

export default QuickLinks;
